<template>
  <div id="app">
    <div v-if="isLoading" class="loading">
      <Jumper :size="90"></Jumper>
    </div>

    <div v-else>
      <header id="header">
        <ul class="header-inner">
          <li class="logo">
            <a href="/">INSCRIPCIONES DE ASPIRANTES</a>
          </li>
        </ul>
      </header>

      <section id="main">
     <!--    <aside id="sidebar">
          <div class="sidebar-inner c-overflow"> -->
<!--             <div class="profile-menu">
              <a href>
                <div class="profile-pic"></div>
                <div class="profile-info"></div>
              </a>
            </div> -->

<!--             <ul class="main-menu" id="main-menu">
              <template v-for="item in dataMenu">
                <li v-if="item.route=='submenu'" class="sub-menu">
                  <a href :class="item.class">
                    <i :class="item.icon"></i>
                    {{ item.title }}
                  </a>
                  <ul>
                    <li v-for="subitem in item.submenu">
                      <a href @click.prevent="goRoute(subitem)">
                        <i :class="subitem.icon"></i>
                        {{ subitem.title }}
                      </a>
                    </li>
                  </ul>
                </li>
                <li v-else>
                  <a href @click.prevent="goRoute(item)" :class="item.class">
                    <i :class="item.icon"></i>
                    {{ item.title }}
                  </a>
                </li>
              </template>

            </ul> -->
<!--           </div>
        </aside> -->

        <section id="content">
          <div id="main-body" class="container">
            <router-view></router-view>
          </div>
        </section>
      </section>
    </div>

    <footer id="footer" style="text-align:center">
      <img  src="./assets/img/unc-logo-footer.png" alt />
    </footer>
  </div>
</template>

<script>
import { HTTPFront } from "./share.js";
import { mapState, mapGetters } from "vuex";
import { Jumper } from "vue-loading-spinner";
//import '@/assets/css/app-core.css'
export default {
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    Jumper,
  },
  computed: {
    //...mapState(["isLoading"]),
  },
  created() {
  },
  methods: {
  },
};
</script>

<style lang="scss">

@import '../src/assets/css/app-core.css';

#sidebar .profile-menu > a {
  display: block;
  height: 129px;
  margin-bottom: 5px;
  width: 100%;
  background: url(./assets/img/2019-PI-INFORMATICA-IMAGEN-2048x1642-12.png) left
    top no-repeat;
  background-size: 100%;
}


.header-inner {
  list-style: none;
  padding: 15px 0;
}

.header-inner > li {
  display: inline-block;
  vertical-align: top;
}

.header-inner > li:not(:last-child) {
  margin-right: -2px;
}

.header-inner .logo a {
  color: #fff;
  text-transform: uppercase;
  padding: 6px 10px;
  display: block;
  font-size: 16px;
  font-weight: 400;
}
</style>

